import { render, staticRenderFns } from "./ShopButton.vue?vue&type=template&id=75c0841a&scoped=true&"
import script from "./ShopButton.vue?vue&type=script&lang=js&"
export * from "./ShopButton.vue?vue&type=script&lang=js&"
import style0 from "./ShopButton.vue?vue&type=style&index=0&id=75c0841a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c0841a",
  null
  
)

export default component.exports